import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./SpecialFeatureRow.css";

export default function SpecialFeatureRow(props) {
  return (
    <div
      className={classNames(styles.root, { [styles.disabled]: !props.public })}
    >
      <span className={styles.name}>{props.name}</span>
      <span className={styles.status}>
        {props.public ? "Public" : "Disabled"}
      </span>
      <span className={styles.url}>{props.url}</span>
    </div>
  );
}

SpecialFeatureRow.propTypes = {
  name: PropTypes.string.isRequired,
  public: PropTypes.bool.isRequired,
  url: PropTypes.string.isRequired,
};
